import './proposed-facts-card.css';

import { Button } from '@kerfjs/ui/button';
import { ContentItem } from '@kerfjs/ui/content-item';
import { List } from '@kerfjs/ui/list';
import { Row } from '@kerfjs/ui/row';
import { TextField } from '@kerfjs/ui/text-field';
import { type SafeHtml } from 'kerfjs';

import { libraryFacts } from '../data/state.js';
import { CardHeader } from './card-header.js';

/**
 * The "Review N proposed facts" card, shown inside the docked AI panel on the
 * Background/Knowledge Base view (HS2-DSMCRT) — an AI-accented confirmation block
 * that lives with the library conversation rather than in the main content column.
 * Renders nothing when there is nothing to review. The `data-fact-*` actions are
 * handled by the existing delegates in init.ts.
 */
export function ProposedFactsCard(): SafeHtml {
  const proposed = libraryFacts.value.filter((f) => f.proposed);
  if (proposed.length === 0) return <></>;
  return (
    <div class="proposed-facts-card">
      <ContentItem appearance="surface" frame="framed">
        <CardHeader title={`Review ${String(proposed.length)} Proposed Fact${proposed.length === 1 ? '' : 's'}`} />
        <List gap="m">
          {proposed.map((f) => (
            <List gap="xs">
              <TextField
                multiline
                ariaLabel="Fact Text"
                size="compact"
                rows={3}
                value={f.text}
                rootAttributes={{ 'data-fact-edit': f.id }}
              />
              <Row hAlign="right" gap="xs">
                <Button size="compact" tone="brand" emphasis="primary" rootAttributes={{ 'data-fact-accept': f.id }}>
                  Accept
                </Button>
                <Button
                  tone="neutral"
                  emphasis="plain"
                  size="compact"
                  ariaLabel="Discard"
                  rootAttributes={{ 'data-fact-delete': f.id }}
                >
                  ✕
                </Button>
              </Row>
            </List>
          ))}
        </List>
      </ContentItem>
    </div>
  );
}
